<template>
    <div class="excel-dialog">
        <!-- 匹配订单护照页-->
        <el-dialog :visible.sync="dialogShow" width="619px" :close-on-click-modal="true" @closed="handleClosed">
            <div class="dialog-member-title">
                <span class="dialog-member-name">批量上传Excel</span>
                <div class="dialog-close" @click="closeFn">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div style="padding: 20px;min-height: 200px; max-height: 60vh; overflow-y: auto;">
                <div style="display: flex;align-items: center;gap: 20px;">
                    <el-upload class="upload_button" multiple accept=".xlsx,.xls" action="" :limit="100"
                        :auto-upload="true" :show-file-list="false" :file-list="excelFileList"
                        :http-request="multipleUploadExcel" :on-exceed="onExcelExceed">
                        <el-link type="primary" :underline="false" style="font-size: 10px;">
                            <el-button size="small" type="primary"><i class="el-icon-view el-icon-download"></i>
                                批量导入excel</el-button>
                        </el-link>
                    </el-upload>

                    <div>
                        <span>选择产品: </span>
                        <!-- 选择要批量的产品id -->
                        <el-select clearable v-model="visaId" style="width: 240px" placeholder="产品" filterable
                            autocomplete="off" remote :remote-method="handleGetordertools" :loading="productloading">
                            <el-option v-for="item in productList" :key="item.id" :label="item.title" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!-- 效果展示表单 -->
                <div class="user-upload-info" v-show="excelTableData.length > 0">
                    <el-table :data="excelTableData" height="50vh" style="width: 100%;margin-top: 10px;"
                        :row-key="new Date().getTime() + ''" v-loading="excelUploadLoading" ref="singleTable">
                        <el-table-column prop="name" label="文件名" width="120" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="marks" label="备注">
                            <template slot-scope="scope">
                                <div style="display: flex;align-items: center;gap: 10px;">
                                    <el-input v-model="scope.row.marks" @input="handleInputChange"></el-input>
                                    <el-input v-model="scope.row.name" readonly></el-input>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="path" label="状态" width="90">
                            <template slot-scope="scope">
                                <template v-if="!scope.row.path">
                                    <i style="color: #FF5967" class="el-icon-warning"></i>
                                    <span style="color: #FF5967;">上传中</span>
                                </template>
                                <template v-else>
                                    <i style="color: #4BD97F" class="el-icon-success"></i>
                                    <span style="color: #4BD97F;">上传成功</span>
                                </template>
                                <!-- </div> -->
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" label="操作" width="90">
                            <template slot-scope="scope">
                                <i class="el-icon-delete" @click="delExcel(scope.row)"></i>
                            </template>
                        </el-table-column>
                    </el-table>

                </div>
            </div>

            <div class="packge-btn-add">
                <div style="display: flex;align-items: center;gap: 10px;">
                    <el-button class="pageck-btn" @click="closeFn">关闭</el-button>
                    <el-upload class="upload_button" v-show="excelTableData.length > 0" multiple accept=".xlsx,.xls"
                        action="" :limit="100" :auto-upload="true" :show-file-list="false" :file-list="excelFileList"
                        :http-request="multipleUploadExcel" :on-exceed="onExcelExceed">
                        <el-button class="pageck-btn default" type="primary" ref="upImg">继续上传</el-button>
                    </el-upload>
                    <el-button class="pageck-btn default" type="primary" @click="handleSubmitExcelData">确认</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import alyoss from "@/utils/alyoss";
import { getordertools } from "@/api/settings";
import {
    orderimportpassport,
    batchprocesstemplate
} from "@/api/order.js";
import { query } from "@/api/personal.js";
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        selectionRow: {
            type: Array,
            default: []
        }

    },
    watch: {
        visible(val) {
            this.dialogShow = val;
        }

    },
    mounted() {
        this.handleGetordertools();
    },
    data() {
        return {
            selectionFileList: [],
            isUploading: false,
            excelFileList: [], // upload excelFileList
            excelTableData: [], // excel列表数据
            inputDebounceTimer: null,
            excelUploadLoading: false,
            productList: [],
            visaId: "",
            productloading: false,
            dialogShow: false,
        }
    },
    methods: {
        onExcelExceed() {
            var vm = this;
            vm.$message({
                message: "只能上传" + 100 + "份,如需替换请先删除已上传的excel文件",
                type: 'warning'
            });
        },
        // 批量上传excel文件
        async multipleUploadExcel(request) {
            // excelTableData
            // 保存下原有的文件名称
            let file = request.file
            let fileName = this.getFileNameWithoutExt(file.name)
            // 上传文件到阿里云
            this.excelTableData.push({
                uid: file.uid,
                name: fileName,
                path: '',
                marks: '',
            })
            let alyossData = await alyoss(file);
            this.excelTableData[this.excelTableData.findIndex(item => item.uid === file.uid)].path = alyossData;
        },
        handleInputChange(e) {
            clearTimeout(this.inputDebounceTimer);
            this.inputDebounceTimer = setTimeout(() => {
                if (e) {
                    this.excelTableData.forEach(item => {
                        item.marks = e
                    })
                }
            }, 500); // 延迟时间：500ms = 0.5秒
        },
        // 获取机构产品数据
        handleGetordertools(e = '') {
            this.productloading = true;
            query({
                Title: e
            }).then(res => {
                console.log(res, 1232132)
                if (res.code == 1) {
                    this.productList = res.data.rows;
                }
            }).finally(() => {
                this.productloading = false;
            })
        },
        // 获取文件名
        getFileNameWithoutExt(fileName) {
            if (!fileName) return ''; // 空值处理
            const lastDotIndex = fileName.lastIndexOf('.');
            // 处理：无点 / 点在开头（如 .env）→ 返回原文件名
            if (lastDotIndex <= 0) {
                return fileName;
            }
            // 截取开头到最后一个点的部分
            return fileName.substring(0, lastDotIndex);
        },
        // 提交excel数据到后台
        handleSubmitExcelData() {
            this.excelUploadLoading = true;
            let datas = this.excelTableData.map(item => {
                return {
                    path: item.path,
                    marks: item.marks + '-' + item.name,
                }
            })
            if (this.excelTableData.length == 0) {
                this.$message.error('请上传文件')
                this.excelUploadLoading = false;
                return
            } else if (this.visaId == '') {
                this.$message.error('请先选择产品')
                this.excelUploadLoading = false;
                return
            }
            batchprocesstemplate({
                datas,
                visaId: this.visaId,
            }).then(res => {
                if (res.code == 1) {
                    this.$message.success('上传成功')
                    this.closeFn();
                } else {
                    this.$message.error(res.msg)
                }
            }).finally(() => {
                this.excelUploadLoading = false;
            })
        },
        submitSelectionUpload() {
            console.log('file', this.selectionRow, this.selectionFileList);
            let ids = this.selectionRow.map(res => res.id);
            let images = this.selectionFileList.map(res => res.url);
            orderimportpassport({ ids, images }).then(() => {
                this.$message.success('操作成功')
                this.selectionFileList = [];
                this.closeFn();
            })
        },
        handleClosed() {
            this.excelTableData = [];
            this.excelFileList = [];
            this.visaId = '';
        },
        async uploadSelectionpage(file) {
            this.selectionFileList.push({ uid: file.file.uid, url: file.file.url, status: 'warning' });
            await alyoss(file.file).then(alyossData => {
                let findIndex = this.selectionFileList.findIndex(res => res.uid == file.file.uid)
                this.selectionFileList[findIndex].url = alyossData;
                this.selectionFileList = [...this.selectionFileList];
            });
        },
        beforeSelectionRemove(file, fileList) {
            return this.$confirm(`是否确定移除？`);
        },
        handleSelectionRemove(file, fileList) {
            let findIndex = this.selectionFileList.findIndex(res => res.uid == file.uid)
            this.selectionFileList.splice(findIndex, 1)
        },
        closeFn() {
            if (this.selectionFileList.length) {
                this.$confirm('关闭弹窗后会清空所有数据，是否关闭?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.selectionFileList = []
                    this.$emit('close')
                })
            } else {
                this.selectionFileList = []
                this.$emit('close')
            }
        }
    }

}
</script>

<style lang="scss">
.excel-dialog {

    .el-dialog {
        background-color: transparent;

        .el-dialog__header {
            display: none !important;
        }

        .el-dialog__body {
            background: linear-gradient(180deg, #e7ecfb 0%, #f6f8fe 24%, #ffffff 100%);
            border-radius: 12px;
            box-sizing: border-box;
            overflow: hidden;
        }
    }
}
</style>